import AppLoading from './AppLoading.vue';
import BasicPopup from './BasicPopup.vue';

import matchOverview from './matchOverview.vue';
import matchAnalysis from './matchAnalysis.vue';
import matchLive from './matchLive.vue';

import downloadPopup from './downloadPopup.vue';
import AppMatchTag from './AppMatchTag.vue'

export {
    AppLoading,
    BasicPopup,

    matchOverview,
    matchAnalysis,
    matchLive,

    downloadPopup,
    AppMatchTag
}



// WEBPACK FOOTER //
// ./src/components/index.js